module.exports = "<div class=\"kt-header__topbar\">\r\n\t<kt-user-profile></kt-user-profile>\r\n</div>\r\n"